import React from 'react';
import {MDBContainer,} from "mdb-react-ui-kit";

const Patientbalanceest = () => {
    return (
        <MDBContainer fluid className="p-0">
        <div className="container py-5">
            <div className="row">
              <div className="col-12">
                  <div className="section-title mb-4 pb-2">
                      <h1 className="title mb-4 display-heading AcerhealthTextPurple text-center fomtsizetest" style={{fontFamily:'Lora, serif'}}> Patient Balance Estimator</h1>
                      <p className="para-desc mx-auto mb-0" style={{fontSize:'20px',fontFamily: 'Alegreya Sans',fontWeight:'500',textAlign: 'justify'  }}>   
                          One of the biggest challenges healthcare providers face today is collecting past-due balances, as they often wait months for compensation
                           after delivering essential care.<b>  <a
                            href="https://mdbill.io/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
                            MDBill’s
                        </a>  patient balance estimator,</b> part of AcerHealth’s advanced <b> medical billing technologies, </b>helps your
                            front desk team determine out-of-pocket patient responsibility, verify insurance eligibility, and access benefit information—all at the point
                             of service. This transparency makes it easier to request payments when patients see exactly what they owe, leading to better collections during 
                             visits. The tool integrates seamlessly with your 
                             
 <a
                            href="https://acerhealth.com/services/medical-billing-services"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
               medical billing services,
                        </a>  
                              strengthens <b>revenue cycle management, </b>and supports <b>medical billing
                              outsourcing </b>processes by reducing revenue leakage, accelerating cash flow, and enhancing compliance with payer requirements—empowering your
                               practice to operate efficiently and profitably.</p>
                  </div>
              </div>
          </div>
        </div>    
        </MDBContainer>
    );
};
export default Patientbalanceest;